// SERVICE
import AppOverlay from '@/components/Overlay'
import Game from '@/game/game'
import { hexColor } from '@/game/utils'

window.log = () => {}

// let targetWs

// Default user options
const DefOptions = {
  speech: false
}

// Player InitialState
let afterAdsJoin

window.aiptag.cmd.player.push(function () {
  // eslint-disable-next-line
  window.adplayer = new window.aipPlayer({
    AD_WIDTH: 960,
    AD_HEIGHT: 540,
    AD_FULLSCREEN: false,
    AD_CENTERPLAYER: true,
    LOADING_TEXT: 'loading advertisement',
    PREROLL_ELEM: function () { return document.getElementById('preroll') },
    AIP_COMPLETE: () => {
      if (afterAdsJoin)afterAdsJoin()
    },
    AIP_REMOVE: function () {
    }
  })
})

function doAfterAdds (cb) {
  let pcount = window.localStorage.getItem('page.acount') || -1
  pcount++
  window.localStorage.setItem('page.acount', pcount)
  if (pcount % 3 !== 0) {
    cb()
    return
  }
  if (typeof window.adplayer === 'undefined') {
    cb()
    return
  }
  afterAdsJoin = cb
  window.aiptag.cmd.player.push(function () { window.adplayer.startPreRoll() })
}

function initialState () {
  return {
    score: 0,
    kills: 0,
    playing: 0,
    starting: false,
    joining: true,
    board: []
  }
}
// Vue js component
export default {
  name: 'App',
  components: { AppOverlay },
  data () {
    const jsonOpt = window.localStorage.getItem('player.options.2')
    const Options = jsonOpt ? JSON.parse(jsonOpt) : DefOptions
    const name = window.localStorage.getItem('player.name')

    return {
      state: initialState(),
      screen: 'loading',
      name: name,
      Options: Options
    }
  },
  watch: {
    Options: {
      handler (val) {
        window.localStorage.setItem('player.options.2', JSON.stringify(val))
      },
      deep: true
    }
  },
  mounted () {
    setTimeout(() => this.createGame(), 100)
  },
  beforeDestroy () {
    this.Game.destroy() // events too
  },
  methods: {
    hexColor: hexColor,
    createGame () {
      this.Game = new Game(this.$refs['canvas-container'], this.gameBoardUpdate.bind(this))
      this.Game.on('state', this.gameBoardUpdate)
      this.Game.on('joined', this.connected)
      this.Game.on('started', this.started)
      this.Game.on('wordClaim', this.wordClaim)

      if (this.$route.params.roomId) {
      // This can be different for multi server
        let schema = 'ws'
        if (window.location.protocol === 'https:') {
          schema = 'wss'
        }
        const host = window.location.host
        const wsURL = schema + '://' + host + '/conn/' + this.$route.params.roomId
        this.targetWs = wsURL
        this.connect()
      }
    },
    toggleAudio () {
      this.Options.speech = !this.Options.speech
    },
    connect () {
      this.Game.connect(this.targetWs, this.name)
    },
    connected (state) {
      this.state.joining = false
      // its a Team room teams
      this.teams = state.room.teams
      if (this.teams) {
        this.screen = 'teams'
        return
      }
      this.start()
    },
    start (opt) {
      this.state.starting = opt
      doAfterAdds(() => this.Game.start(opt))
    },
    started () {
      this.state.starting = null
    },
    gameBoardUpdate (state) {
      if (this.state.playing !== state.playing && state.playing === 3) {
        this.screen = 'gameover'
      }
      // this.$set(this.state, state)
      Object.assign(this.state, state)
    },
    wordClaim (wordClaim) {
      if (this.Options.speech) {
        var msg = new window.SpeechSynthesisUtterance(wordClaim.word)
        msg.rate = 1
        msg.lang = wordClaim.lang
        window.speechSynthesis.speak(msg)
      }
    }
  }
}
